import * as yup from 'yup';
import { errors } from '../messages';

const schema = yup.object().shape({
  browser: yup.string().required(errors.MISSING_REPORT_BUG_BROWSER),
  description: yup.string().required(errors.MISSING_REPORT_BUG_DESCRIPTION),
});

export default schema;
